export default import.meta.ROLLDOWN_FILE_URL_Y3gp9tZ0KweSZ0Dya1OcxQ